import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../configure';

export interface IUserState {
  // TODO: Replace `any` with specific type
  /* eslint-disable @typescript-eslint/no-explicit-any */
  data?: any;
}

export const initialState: IUserState = {
  data: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateChartData: (state, data) => {
      state.data = data.payload;
    },
  },
});

export const { updateChartData } = userSlice.actions;

export const selectChart = (state: RootState) => state.chart;

export default userSlice.reducer;
